<template>
    <div class="order-infoTab-section1">
        <div class="order-pay-record">
            <el-table :data="logs" border style="width: 100%" class="tabTopBorder" v-loading="loading">
                <el-table-column prop="old_user_name" label="原业务员"></el-table-column>
                <el-table-column prop="new_user_name" label="流转人"></el-table-column>
                <el-table-column prop="created_at" label="流转时间"></el-table-column>
                <el-table-column prop="memo" label="流转"></el-table-column>
            </el-table>
            <el-row v-if="linkPage">
                <pagination :linkPage="linkPage" :enableEvent="true" @change="watchPageChange"></pagination>
            </el-row>
        </div>
    </div>
</template>

<script>
    import CustomerService from "~/services/customer.js";
    import Pagination from "~/widgets/Pagination.vue";

    export default {
        name: "TransitLogs",
        components: {
            Pagination
        },
        props: {
            customerId: {
                type: Number,
                default: 0,
                required: true
            },
        },
        data() {
            return {
                logs: [],
                linkPage: null,
                loading: false,
            }
        },
        created() {
            if (this.logs.length == 0) {
                this.getTransitLog();
            }
        },
        methods: {
            getTransitLog() {
                this.loading = true;
                CustomerService.getTransitLog({customer_id: this.customerId}).then(res => {
                    if (res.code == 0) {
                        this.logs = res.data;
                        if (res._meta) {
                            this.linkPage = res._meta;
                        }
                        this.loading = false;
                    }
                })
            },

            /**
             * 监听分页改变事件
             * @param pageParams
             */
            watchPageChange(pageParams) {
                this.getTransitLog({
                    page: pageParams["page"],
                    perPage: pageParams["perPage"],
                    customer_id: this.customerId,
                });
            },

        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/customer/TransitLogs.vue